import types from './types';
import create from '~/misc/create';
import get from 'lodash/get';

import {promiseAction, ActionError} from '~/misc/dispatch';
import {getAdminAccountInfo} from '../adminAccountPage/actions';
import {getUserData} from '~/modules/user/actions';
import HTTPError from '~/misc/HTTPError';
import * as api from './api';

export const saveAccountInfo = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.PROFILE_PAGE_SAVE_ACCOUNT_INFO,
  api.saveAccountApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const saveAccountInfoAndGetAdminAccountInfo = (dispatch, getState, val) => {
  const token = get(getState(), 'user.token');
  return promiseAction(
    dispatch,
    getState,
    types.SAVE_ACCOUNT_INFO_WRAP,
    saveAccountInfo(dispatch, getState, val)
      .then(() => getAdminAccountInfo(dispatch, getState))
      .then(() => getUserData(dispatch, getState, token))
  );
};

export const saveAccountInfoAndGetAdminAccountInfoAction = (val) => (dispatch, getState) => {
  const token = get(getState(), 'user.token');
  return promiseAction(
    dispatch,
    getState,
    types.SAVE_ACCOUNT_INFO_WRAP,
    saveAccountInfo(dispatch, getState, val)
      .then(() => getAdminAccountInfo(dispatch, getState))
      .then(() => getUserData(dispatch, getState, token))
  );
}

export const hideAsyncErrorMessage = (dispatch, val) => dispatch(create(types.PROFILE_PAGE_ASYNG_ERROR_HIDE, val));





// WEBPACK FOOTER //
// ./src/modules/accountProfilePage/actions.js